@for (tenant of tenants_(); track $index) {
	<app-container class="pt-2" [class]="{ 'mt-4': $index > 0 }">
		<div class="flex gap-2 w-full mt-2">
			<div class="w-10">
				<atomic-name-badge size="small" [initials]="tenantInitials(tenant)" />
			</div>
			<div class="grow">
				<div>
					<h6 class="text-sm font-semibold">{{ tenant?.fullName }}</h6>
				</div>

				<div class="text-grey text-xs">
					Tenant {{ $index + 1 }} |
					@if (tenant?.phoneNumber) {
						<a
							[href]="`tel:${tenant.phoneNumber}`"
							target="_blank"
							externalNavInterceptor
							class="hover:text-green hover:underline cursor-pointer"
							>{{ tenant.phoneNumber }}</a
						>
					}
				</div>
			</div>
			<div class="w-8 text-right">
				<atomic-kebab-options
					(onSelect)="onKebabOptionSelected($event, tenant)"
					[itemGroups]="[{ items: kebabOptions }]"
				/>
			</div>
		</div>
	</app-container>
}
